import { defineMessages } from "@/i18n";
import en from "./en";

export const panelsTaskScheduleMessages = defineMessages(
  "panels-task-schedule",
  en,
);
